import { render, staticRenderFns } from "./approve_by_id.vue?vue&type=template&id=1353ad28&scoped=true&"
import script from "./approve_by_id.vue?vue&type=script&lang=js&"
export * from "./approve_by_id.vue?vue&type=script&lang=js&"
import style0 from "./approve_by_id.vue?vue&type=style&index=0&id=1353ad28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1353ad28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
